module.exports = __webpack_public_path__ + "media/resume_rev/resume-rev-video-card-images-05-59d49c93.jpg";